<div class="text-right places" [ngClass]="{ 'custom-places': isCustom }">
  <div *ngIf="customPlaces && address" class="mt-3 mb-3 places-text">
    <h5 class="mt-2 fs-18">{{ address?.label }}</h5>
  </div>
  <div class="">

    <agm-map [zoom]="8" [latitude]="lat" [longitude]="long">
      <agm-marker *ngFor="let place of places" [latitude]="place?.latitude" [longitude]="place?.longitude"   [animation]="'BOUNCE'">
        <agm-info-window>
          <label class="mt-2 fs-20" (click)="openItinerary(place)">
            {{place?.title}}

          </label>
        </agm-info-window>
      </agm-marker>

  
    </agm-map>

  </div>
  <div *ngIf="!customPlaces" class="mt-3 places-text">
    <div *ngFor="let place of places" class="mt-3 places_item">

      <button class="d-flex align-items-center justify-content-center gap-2 btn btn-primary"
        (click)="openItinerary(place)">
    
        <i class="fas fa-map-marker-alt"></i>
        {{ place?.title }}
         فتح في خرائط جوجل
      </button>

    </div>
  </div>
</div>